<template>
  <div class="standing">
    <h4 class="title">standings</h4>
    <app-show-more :info="info" class="blue" :class="info.class"></app-show-more>
    <div class="table vgt-wrap small">
      <div class="vgt-inner-wrap">
        <div class="vgt-responsive">
          <div class="table vgt-table">
            <div class="table-header">
              <div class="vgt-left-align">
                <span>Position</span>
              </div>
              <div class="vgt-left-align">
                <span>Team</span>
              </div>
              <div class="vgt-left-align">
                <span>Points</span>
              </div>
            </div>
            <div class="table-body">
              <div :class="rowStyleClassFn(team)" v-for="team in teamSort" :key="team.id">
                <div class="vgt-left-align">
                  <span>{{team.position}}</span>
                </div>
                <div class="vgt-left-align">
                  <div class="title">
                    <span>{{team.name}}</span>
                  </div>
                </div>
                <div class="vgt-left-align">
                  <span>{{team.points}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Show_more from "@/components/shared/Show_more";
const url = process.env.VUE_APP_URL;
export default {
  data() {
    return {
      info: {
        url: "/standings",
        class: "line",
      },
      filterValue: true,
      season: "",
      seasonTeam: [],
    };
  },
  computed: {
    teamSort() {
      var seasonTeam = [];
      this.seasonTeam.map((el) => {
        el.teamStats.map((elem) => {
          elem.goalsDifferencial = elem.goalsFor - elem.goalsAgainst;
          if (elem.season.period == this.season) {
            return elem;
          }
        });
        if (el.teamStats.length != 0) {
          seasonTeam.push(el);
        }
      });
      this.sortPoints(seasonTeam);
      this.positionCheck(seasonTeam);
      if (this.filterValue === true) {
        seasonTeam = this.filterTeams(seasonTeam);
        return seasonTeam;
      } else return seasonTeam;
    },
  },
  methods: {
    setSeasons() {
      this.axios
        .get(url + "/seasons", {
          headers: {
            "Access-Control-Allow-Origin": "*",
            accept: "application/json",
          },
        })
        .then((response) => {
          const payload = response.data;
          this.$store.dispatch("setSeasons", payload);
          this.seasons();
        });
    },
    seasons() {
      var seasons = this.$store.getters.seasons;
      seasons.map((el) => {
        if (el.isMain === true) {
          this.season = el.period;
        }
      });
      this.teamsSeasons();
    },
    teamsSeasons() {
      var teamsALL = JSON.parse(JSON.stringify(this.$store.getters.teams)),
        season = [];

      teamsALL.map((el) => {
        var newState = [];
        el.teamStats.map((elem) => {
          if (elem.season.period == this.season) {
            newState.push(elem);
          }
        });

        if (newState.length != 0) {
          el.teamStats = newState;
          season.push(el);
        }
      });

      this.seasonTeam = season;
    },
    rowStyleClassFn(row) {
      return row.name == "Bridgeport Utd" ? "active" : false;
    },
    sortPoints(arr) {
      arr.map((el) => {
        var points = 0;
        if (el.teamStats) {
          el.teamStats.map((elem) => {
            points = elem.win * 3 + elem.draw * 1;
          });
        }
        el.points = points;
      });
      arr.sort((a, b) => {
        if (a.points > b.points) {
          return -1;
        } else if (a.points == b.points) {
          var el1 = "",
            el2 = "";
          a.teamStats.map((el) => {
            el1 = el.goalsDifferencial;
          });
          b.teamStats.map((el) => {
            el2 = el.goalsDifferencial;
          });

          return el1 > el2 ? -1 : 1;
        } else {
          return 1;
        }
      });
    },
    positionCheck(arr) {
      arr.forEach(function (el, index) {
        el.position = index + 1;
      });
    },
    filterTeams(arr) {
      if (arr.length > 7) {
        arr = arr.slice(0, 9);
        arr.splice(4, 3, { points: ". . .", position: ". . ." });
      }
      return arr;
    },
  },
  mounted() {
    this.setSeasons();
  },
  components: {
    "app-show-more": Show_more,
  },
};
</script>
<style lang="scss" scoped>
.standing {
  width: 31.5%;
  @media (max-width: 992px) {
    width: 100%;
  }
}
</style>